export const blockIconsTravelFoodBankNew = (
	<span className='material-symbols-outlined'>food_bank</span>
);
